module.exports = __webpack_public_path__ + "static/media/youtube.bcfb7181.svg";